import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import CameraCapture from '../../camera-capture';

function CameraModal({ isCameraModalOpen, onClose, onAdd }) {
  return (
    <Modal
      open={isCameraModalOpen}
      onClose={onClose}
      classNames={{
        modal: 'camera-modal',
        overlay: 'camera-overlay',
        closeButton: 'camera-modal__close-btn'
      }}
    >
      <CameraCapture handleFile={onAdd} closeModal={onClose} />
    </Modal>
  );
}

CameraModal.propTypes = {
  isCameraModalOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onAdd: PropTypes.func
};

CameraModal.defaultProps = {
  onClose: () => {},
  onAdd: () => {}
};

export default CameraModal;
